import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import WhyTrust from "@/components/sections/WhyTrust";
import Services from "@/components/sections/Services";
import Pricing from "@/components/sections/Pricing";
import Structures from "@/components/sections/Structures";
import Partners from "@/components/sections/Partners";
import Booking from "@/components/sections/Booking";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <main className="bg-[#050505] text-white min-h-screen overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <Hero />
      <About />
      <WhyTrust />
      <Services />
      <Pricing />
      <Structures />
      <Partners />
      <Booking />
      <Contact />
      <Footer />
    </main>
  );
}
